"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ArrowForward = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? 2 : _c;
    return (react_1.default.createElement("svg", { width: "17", height: "18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M2 9h14M8 1l8 8-8 8", stroke: color, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = ArrowForward;
//# sourceMappingURL=ArrowForward.js.map